export default __webpack_public_path__ + "static/media/babies.18571bc5.webp";